module.exports = __webpack_public_path__ + "static/media/layer-minus.70a651f6.svg";